function hydrateNavigationImages(root) {
  root.querySelectorAll('img[data-navigation-src]').forEach((image) => {
    if (image.dataset.navigationSrcset) image.srcset = image.dataset.navigationSrcset;
    image.src = image.dataset.navigationSrc;
    image.removeAttribute('data-navigation-src');
    image.removeAttribute('data-navigation-srcset');
  });
}

class NavigationProductionDesktop extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('[data-navigation-root-item]')];
    this.boundDocumentClick = this.onDocumentClick.bind(this);
    this.items.forEach((item, index) => {
      const trigger = item.querySelector(':scope > [data-navigation-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', () => this.toggle(item));
      trigger.addEventListener('keydown', (event) => this.onTriggerKeydown(event, index));
      item.addEventListener('keydown', (event) => this.onItemKeydown(event, item));
      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'touch') this.open(item);
      });
      item.addEventListener('pointerleave', () => {
        if (item.dataset.navPinned === 'true') return;
        window.clearTimeout(this.closeTimer);
        this.closeTimer = window.setTimeout(() => this.close(item), 170);
      });
      item.addEventListener('pointerenter', () => window.clearTimeout(this.closeTimer));
    });
    document.addEventListener('click', this.boundDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.boundDocumentClick);
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.closeAll();
  }

  onTriggerKeydown(event, index) {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      const offset = event.key === 'ArrowRight' ? 1 : -1;
      const nextIndex = (index + offset + this.items.length) % this.items.length;
      this.items[nextIndex].querySelector('[data-navigation-trigger], a')?.focus();
    }
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      const item = this.items[index];
      this.open(item);
      item.querySelector('[data-navigation-panel] a')?.focus();
    }
  }

  onItemKeydown(event, item) {
    if (event.key !== 'Escape') return;
    const trigger = item.querySelector(':scope > [data-navigation-trigger]');
    if (trigger?.getAttribute('aria-expanded') !== 'true') return;
    event.preventDefault();
    event.stopPropagation();
    this.close(item);
    trigger.focus();
  }

  toggle(item) {
    const expanded = item.querySelector('[data-navigation-trigger]')?.getAttribute('aria-expanded') === 'true';
    if (expanded) {
      if (item.dataset.navPinned === 'true') {
        this.close(item);
      } else {
        item.dataset.navPinned = 'true';
      }
    } else {
      this.closeAll(item);
      item.dataset.navPinned = 'true';
      this.open(item);
    }
  }

  open(item) {
    this.closeAll(item);
    const trigger = item.querySelector('[data-navigation-trigger]');
    const panel = item.querySelector('[data-navigation-panel]');
    if (!trigger || !panel) return;
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    if ('inert' in panel) panel.inert = false;
    hydrateNavigationImages(panel);
    this.track('nav_menu_open', item.dataset.navPanel, 'panel', item.dataset.navPanel, '');
  }

  close(item) {
    const trigger = item.querySelector('[data-navigation-trigger]');
    const panel = item.querySelector('[data-navigation-panel]');
    if (!trigger || !panel) return;
    trigger.setAttribute('aria-expanded', 'false');
    delete item.dataset.navPinned;
    panel.hidden = true;
    if ('inert' in panel) panel.inert = true;
  }

  closeAll(except) {
    this.items.forEach((item) => {
      if (item !== except) this.close(item);
    });
  }

  track(eventName, panel, itemType, itemId, destinationUrl) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, surface: 'desktop', panel, item_type: itemType, item_id: itemId, destination_url: destinationUrl });
  }
}

if (!customElements.get('navigation-production')) customElements.define('navigation-production', NavigationProductionDesktop);

document.querySelectorAll('[data-navigation-mobile] > details').forEach((drawer) => {
  drawer.addEventListener('toggle', () => {
    const isOpen = drawer.open;
    document.querySelectorAll('#MainContent, footer').forEach((region) => {
      if ('inert' in region) region.inert = isOpen;
    });
    if (isOpen) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'nav_menu_open', surface: 'mobile', panel: 'root', item_type: 'drawer', item_id: 'mobile_drawer', destination_url: '' });
    }
  });
});

document.querySelectorAll('.navigation-mobile-panel').forEach((panel) => {
  panel.addEventListener('toggle', () => {
    if (panel.open) hydrateNavigationImages(panel);
  });
});

document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-navigation-link]');
  if (!link) return;
  const shell = link.closest('[data-nav-surface]');
  const panel = link.closest('[data-nav-panel]')?.dataset.navPanel || '';
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'mega_menu_click',
    menu_item: link.textContent.trim(),
    menu_url: link.href,
    surface: shell?.dataset.navSurface || '',
    panel,
    item_type: link.dataset.navItemType || 'link',
    item_id: link.dataset.navItemId || '',
    destination_url: link.href
  });
});

document.addEventListener('click', (event) => {
  const back = event.target.closest('[data-navigation-back]');
  if (!back) return;
  const details = back.closest('details');
  if (!details) return;
  const summary = details.querySelector(':scope > summary');
  details.open = false;
  summary?.focus();
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const openNested = event.target.closest('.navigation-production--mobile')?.querySelector('details details[open]');
  if (openNested) {
    const summary = openNested.querySelector(':scope > summary');
    openNested.open = false;
    summary?.focus();
  }
});
